module.exports = __webpack_public_path__ + "media/images/banner-cancer-insurance-20d016e0f5f0a5ae11a1faf6cc1a191f.jpg";